import Component from '@glimmer/component';

export default class MwPostHeader extends Component {}
